// Mock data for PrestaNet website

export const branches = [
  {
    id: 1,
    name: "Guadalajara",
    address: "Av. Chapultepec #123, Col. Americana",
    phone: "33 2969 8523",
    hours: "Lunes a Viernes: 9:00 AM - 6:00 PM\nSábado: 9:00 AM - 2:00 PM"
  },
  {
    id: 2,
    name: "Michoacán",
    address: "Calle Morelos #456, Centro",
    phone: "33 2969 8523",
    hours: "Lunes a Viernes: 9:00 AM - 6:00 PM\nSábado: 9:00 AM - 2:00 PM"
  },
  {
    id: 3,
    name: "Guerrero",
    address: "Av. Insurgentes #789, Col. Centro",
    phone: "33 2969 8523",
    hours: "Lunes a Viernes: 9:00 AM - 6:00 PM\nSábado: 9:00 AM - 2:00 PM"
  },
  {
    id: 4,
    name: "Colima",
    address: "Calle Hidalgo #321, Col. Centro",
    phone: "33 2969 8523",
    hours: "Lunes a Viernes: 9:00 AM - 6:00 PM\nSábado: 9:00 AM - 2:00 PM"
  },
  {
    id: 5,
    name: "San Luis Potosí",
    address: "Av. Carranza #654, Col. Tequisquiapan",
    phone: "33 2969 8523",
    hours: "Lunes a Viernes: 9:00 AM - 6:00 PM\nSábado: 9:00 AM - 2:00 PM"
  },
  {
    id: 6,
    name: "Tepic",
    address: "Av. México #987, Col. Centro",
    phone: "33 2969 8523",
    hours: "Lunes a Viernes: 9:00 AM - 6:00 PM\nSábado: 9:00 AM - 2:00 PM"
  }
];

export const loanTerms = {
  weeks: 14,
  interestRate: 40,
  openingFee: 5,
  penaltyWeeks: 1,
  maxFailures: 3
};

export const features = [
  {
    title: "Montos Accesibles",
    description: "Comenzamos con montos pequeños adaptados a tus necesidades",
    icon: "coins"
  },
  {
    title: "Pagos Semanales",
    description: "Pagos cómodos cada semana durante 14 semanas",
    icon: "calendar"
  },
  {
    title: "Proceso Rápido",
    description: "Aprobación rápida y sencilla de persona a persona",
    icon: "zap"
  },
  {
    title: "Sin Complicaciones",
    description: "Requisitos mínimos y proceso transparente",
    icon: "check-circle"
  }
];

export const howItWorksSteps = [
  {
    step: 1,
    title: "Solicita tu Crédito",
    description: "Contacta con nosotros por teléfono, correo o visita una sucursal"
  },
  {
    step: 2,
    title: "Evaluación Rápida",
    description: "Revisamos tu solicitud de manera personalizada"
  },
  {
    step: 3,
    title: "Recibe tu Préstamo",
    description: "Una vez aprobado, recibe tu dinero de inmediato"
  },
  {
    step: 4,
    title: "Paga Semanalmente",
    description: "Realiza pagos cómodos cada semana durante 14 semanas"
  }
];

export const faqs = [
  {
    question: "¿Cuánto es la tasa de interés?",
    answer: "Nuestra tasa de interés es del 40% sobre el monto del préstamo a 14 semanas."
  },
  {
    question: "¿Hay cuota de apertura?",
    answer: "Sí, el primer crédito tiene un monto de apertura del 5%. Esta cuota no se vuelve a cobrar a menos que falles en algún pago."
  },
  {
    question: "¿Qué pasa si no puedo pagar una semana?",
    answer: "Si fallas 3 veces en tus pagos, se agregará una semana más al plazo, extendiendo el préstamo a 15 semanas."
  },
  {
    question: "¿Cuánto tiempo dura el préstamo?",
    answer: "El plazo normal es de 14 semanas con pagos semanales. En caso de 3 faltas, se extiende a 15 semanas."
  }
];

export const contactInfo = {
  phone: "33 2969 8523",
  email: "quierocredito@prestanet.com.mx",
  whatsapp: "5213329698523"
};
